import { createSlice } from '@reduxjs/toolkit'
import { IPreferences } from '../../models/api-user-data'

export interface UserState {
  uid: string
  preferences: IPreferences
  token: string
}

export const INITIAL_STATE = {
  uid: null,
  preferences: {},
  token: null
}

const userSlice = createSlice({
  name: 'user',
  initialState: INITIAL_STATE,
  reducers: {
    setToken: (state, action) => {
      return { ...state, token: action.payload }
    }
  }
})

export const { setToken } = userSlice.actions

export default userSlice.reducer
